/* eslint-disable react/prop-types */
import { Button } from "reactstrap";
import "./styles.css";
import { formatarMoeda, formatarMoedaDolar } from "../../../../../utils/formatMoeda";
import api from "../../../../../services/axiosConfig";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function CardNFAdmin({
  isEmiting,
  values,
  tipoContaNF,
  nfId,
  status,
  statusPagamento,
  buscarNotasFiscais,
  selectedDatePeriod,
  tipoNota,
  nota
}) {

  const formatarData = (timestamp) => {
    const data = new Date(timestamp);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const formatarPeriodoReferencia = (timestamp) => {
    const dataBase = new Date(timestamp);
    dataBase.setMonth(dataBase.getMonth() - 2);

    const primeiroDia = new Date(dataBase.getFullYear(), dataBase.getMonth(), 1);
    const ultimoDia = new Date(dataBase.getFullYear(), dataBase.getMonth() + 1, 0);

    return `${formatarData(primeiroDia)} a ${formatarData(ultimoDia)}`;
  };

  const handleCancelarNota = async () => {
    const confirm = await Swal.fire({
      title: "Cancelar Nota Fiscal?",
      text: "Essa ação não poderá ser revertida.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, cancelar",
      cancelButtonText: "Voltar",
    });

    if (confirm.isConfirmed) {
      try {
        await api.patch(`/nf/cancelar-nota/${nfId}`, { status: "cancelado" });
        toast.success("Nota fiscal cancelada com sucesso!");
        await buscarNotasFiscais(selectedDatePeriod);
      } catch (error) {
        console.error("Erro ao cancelar a nota fiscal:", error);
        toast.error("Erro ao cancelar a nota fiscal.");
        throw new Error("Erro ao cancelar a nota fiscal:", error);
      }
    }
  };

  const handleWarn = () => {
    const text = `Para garantir o pagamento,
a nota fiscal do mês corrente deve ser enviada até o dia 10. <br /> <br /> 
Notas enviadas até às 16h do dia 01 (dia útil) serão pagas no mesmo dia. <br /> <br /> 
As notas enviadas entre os dias 02 e 10 serão pagas no dia 11 (ou próximo dia útil). <br /> <br /> 
Caso a nota não seja emitida até o dia 10 do mês seguinte, o valor será doado, caracterizando renúncia ao recebimento.<br /><br />  
A medida visa maior previsibilidade e agilidade nos pagamentos.`;

    Swal.fire({
      title: "Sobre o Pagamento",
      html: text,
      icon: "warning",
    });
  };

  return (
    <div className="cardNFAdmin">
      <h3 className="NfTitle">Referencia de receita</h3>
      <h5 className="NfDate">
        {formatarPeriodoReferencia(nota.createdAt)}
      </h5>

      <div className="NfContent">
        {nota.tipoConta !== "afiliado" && (
          <>
            <div className="NfRow">
              <span className="NfLabel">Total em dólar</span>
              <span className="value positive">
                $
                {formatarMoedaDolar(values?.receitaBruta || values?.totalDolar || values?.valorEmReal)}
              </span>
            </div>
            

            {tipoNota !== "comissao" && 
              <>

                <div className="NfRow">
                  <span className="NfLabel">Taxa do Google</span>
                  <span className="value positive">{values?.taxaGoogle}</span>
                </div>

                {tipoContaNF && tipoContaNF === "usuario" && (
                  <div className="NfRow">
                    <span className="NfLabel">Taxa da plataforma</span>
                    <span className="value positive">{values?.taxaPlataforma}</span>
                  </div>
                )}

                <div className="NfRow">
                  <span className="NfLabel">Porcentagem da divisão</span>
                  <span className="value positive">{values?.porcentagemDivisao}</span>
                </div>

                <div className="NfRow">
                  <span className="NfLabel">Líquido em dólar</span>
                  <span className="value positive">
                    {/* values.totalLiquido vem de emitir nota fiscal e liquidoDolar vem de minhas notas fiscais  */}
                    $
                    {formatarMoedaDolar(
                      values?.totalLiquido || values?.liquidoDolar
                    )}
                  </span>
                </div>

                <div className="NfRow">
                  <span className="NfLabel">Cotação do dólar</span>
                  <span className="value positive">
                    ${formatarMoedaDolar(values?.cotacaoDolar)}
                  </span>
                </div>

                {nota.tipoConta !== "afiliado" && (
                  <>
                    <div className="NfRow">
                      <span className="NfLabel">Valor em real</span>
                      <span className="value positive">
                        R$ {formatarMoeda(values?.valorEmReal)}
                      </span>
                    </div>

                    <div className="NfRow">
                      <span className="NfLabel">Descontos</span>
                      <span className="value negative">
                        - R${" "}
                        {formatarMoeda(values?.descontos || values?.totalDescontos)}
                      </span>
                    </div>
                    <div className="NfRow discountItem">
                      <span>{values?.obsDesconto && `${values?.obsDesconto}`}</span>
                    </div>
                    <hr className="divider" />
                  </>
                )}
              </>
            }
          </>
        )}
        
        {nota.tipoConta === "afiliado" && 
          <>
            <div className="NfRow">
              <span className="NfLabel">Total em dólar</span>
              <span className="value positive">
                $
                {formatarMoedaDolar(values?.receitaBruta || values?.totalDolar || values?.valorEmReal)}
              </span>
            </div>
             <div className="NfRow">
              <span className="NfLabel">Cotação do dólar</span>
              <span className="value positive">
                ${formatarMoedaDolar(values?.cotacaoDolar)}
              </span>
            </div>
            <div className="NfRow">
              <span className="NfLabel">Valor em real</span>
              <span className="value positive">
                R$ {formatarMoeda(values?.valorEmReal)}
              </span>
            </div>

            <div className="NfRow">
              <span className="NfLabel">Sua Porcentagem</span>
              <span className="value positive">{nota?.porcentagem}%</span>
            </div> 
          </>
        }        

        <div className="NfRow">
          <span className="NfLabel">
            Sua {nota?.tipoConta === "afiliado" ? "comissão" : "parte"}
          </span>
          <span className="value positive">
            R${" "}
            {formatarMoeda(
              values?.valorComDesconto || values?.valorEmRealComDesconto
            )}
          </span>
        </div>

        <div className="NfRow">
          <span className="NfLabel">Data para pagamento</span>
          <span
            className="value paymentWarn"
            style={{ cursor: "pointer" }}
            onClick={handleWarn}
          >
            Ver mais
          </span>
        </div>        

        {(status || values?.status) && (
          <div className="NfRow">
            <span className="NfLabel">Status</span>
            <span
              className={`value ${
                values?.status || status === "pendente"
                  ? "pendent"
                  : values?.status || status === "cancelado"
                  ? "cancelled"
                  : values?.status || status === "emitida"
                  ? "issued"
                  : values?.status || status === "pago"
                  ? "payed"
                  : ""
              }`}
            >
              {values?.status || status}
            </span>
          </div>
        )}

        {(nota?.tipoConta === "usuario" ||
          nota?.tipoConta === "influenciador") &&
          !isEmiting && (
            <div className="NfRow">
              <span className="NfLabel">Status pagamento</span>
              <span className={`value`}>{statusPagamento}</span>
            </div>
          )}

        {!isEmiting &&
          status !== status &&
          values?.status !==
            values?.status(
              <>
                <Button
                  color="danger"
                  style={{ marginTop: "1rem" }}
                  onClick={handleCancelarNota}
                >
                  Cancelar Nota Fiscal
                </Button>
              </>
            )}
      </div>
    </div>
  );
}

export default CardNFAdmin;
